import { render, staticRenderFns } from "./AlertEmailSetting.vue?vue&type=template&id=5905077a&"
import script from "./AlertEmailSetting.vue?vue&type=script&lang=js&"
export * from "./AlertEmailSetting.vue?vue&type=script&lang=js&"
import style0 from "./AlertEmailSetting.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports